module.exports = __webpack_public_path__ + "static/media/dr-fafa-amedor-dashen-opticians.bc08d92c.jpeg";